import { useCCEntity } from "components/CC/context/CCEntityContext.tsx";
import { DrawerId, FormId } from "components/CC/types/models.ts";
import { BaseConnectionCreatorDrawer } from "components/CC/UI/BaseConnectionCreatorDrawer.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation.tsx";

import { SetForm } from "../Forms/SetForm.tsx";

export const SetDrawer = () => {
    const { formFields, customFields } = useCCEntity();
    const { t } = usePaldockTranslation("components.connection-creator");

    return (
        <BaseConnectionCreatorDrawer drawerId={DrawerId.Set} title={t("nodes.set.drawers.title")}>
            <SetForm formId={FormId.SetForm} formFields={formFields} customFields={customFields} />
        </BaseConnectionCreatorDrawer>
    );
};
